import { Injectable } from '@angular/core';
import { CollectionPaths } from '@models/collections';
import { MatterPackageHistoryEntry } from '@models/matter-package';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { FirestoreRepo } from '@repos/firestore-repo.service';
import { BusinessState } from '@state/business';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class MatterPackageHistoryService extends FirestoreRepo<
	MatterPackageHistoryEntry,
	null
> {
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@SelectSnapshot(BusinessState.businessId) businessId: string;

	private currentPackageId: string;

	constructor() {
		super(() =>
			CollectionPaths.business_matter_package_history(
				this.businessId,
				this.matterId,
				this.currentPackageId,
			),
		);
	}

	private packageHistoryEntries = new BehaviorSubject<
		MatterPackageHistoryEntry[]
	>([]);

	public setPackageHistoryEntries(entries: MatterPackageHistoryEntry[]) {
		this.packageHistoryEntries.next(entries);
	}

	public get packageHistoryEntries$(): Observable<MatterPackageHistoryEntry[]> {
		return this.packageHistoryEntries.asObservable();
	}

	public getHistoryForPackage(
		packageId: string,
	): Observable<MatterPackageHistoryEntry[]> {
		this.currentPackageId = packageId;
		return this.All();
	}

	public async deleteHistoryForPackage(packageId: string) {
		this.currentPackageId = packageId;
		const entries = await this.All().pipe(take(1)).toPromise();
		if (!entries?.length) return;

		const batch = this.Batch();
		entries.forEach((entry) => {
			if (entry.id) {
				batch.delete(this.DocRef(entry.id));
			}
		});

		return batch.commit();
	}
}
